import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import { Text } from 'blaze-ui/Text/Text'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { MobileButton } from 'components/Design/MobileButton/MobileButton'
import {
  AlignCenter,
  AlignDown2,
  AlignLeft,
  AlignLeft2,
  AlignRight,
  AlignRight2,
  AlignUp2,
  AlignVerticalCenter,
} from 'blaze-ui/icons'
import { AlignHorizontalCenter1 } from 'blaze-ui/icons/24'
import Styles from '../ShapesTab.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { DefaultHorizontalAlignStyle, track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { TextBoxShape } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'
import { capitalize } from 'lodash'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'

const MobileAlignment = track(() => {
  const actions = useActions()
  const editor = useEditor()
  const updateStyle = useUpdateStyle(editor)
  const selectedShape = editor.getOnlySelectedShape()
  const textBoxShape = selectedShape?.type === 'textBox' ? (selectedShape as TextBoxShape) : undefined

  return (
    <>
      {textBoxShape && (
        <div className={Styles.textSection}>
          <Text variant="smallList">Alignment</Text>
          <div className={Styles.mobileAlignmentButtons}>
            {['start', 'middle', 'end'].map((alignment, index) => (
              <MobileButton
                key={index}
                icon={
                  // TODO: Fix this the next time the file is edited.
                  /* eslint-disable-next-line no-nested-ternary */
                  alignment === 'start' ? AlignLeft : alignment === 'middle' ? AlignCenter : AlignRight
                }
                aria-label={`Align ${alignment}`}
                onPress={() => updateStyle(DefaultHorizontalAlignStyle, alignment)}
                isActive={textBoxShape.props.align === alignment}
              >
                {capitalize(alignment)}
              </MobileButton>
            ))}
          </div>
        </div>
      )}
      <div className={Styles.textSection}>
        <Text variant="smallList">Alignment to canvas</Text>
        <div className={Styles.mobileAlignmentButtons}>
          <MobileButton
            aria-label="Align horizontal centers"
            icon={AlignVerticalCenter}
            onPress={() => actions['align-center-horizontal'].onSelect()}
          >
            Center
          </MobileButton>
          <MobileButton aria-label="Align top" icon={AlignUp2} onPress={() => actions['align-top'].onSelect()}>
            Top
          </MobileButton>
          <MobileButton
            aria-label="Align vertical centers"
            icon={AlignHorizontalCenter1}
            onPress={() => actions['align-center-vertical'].onSelect()}
          >
            Middle
          </MobileButton>
          <MobileButton aria-label="Align left" icon={AlignLeft2} onPress={() => actions['align-left'].onSelect()}>
            Left
          </MobileButton>
          <MobileButton aria-label="Align bottom" icon={AlignDown2} onPress={() => actions['align-bottom'].onSelect()}>
            Bottom
          </MobileButton>
          <MobileButton aria-label="Align right" icon={AlignRight2} onPress={() => actions['align-right'].onSelect()}>
            Right
          </MobileButton>
        </div>
      </div>
    </>
  )
})

const DesktopAlignment = () => {
  const actions = useActions()

  return (
    <div className={Styles.textSection}>
      <Text variant="smallList">Alignment to canvas</Text>
      <div className={Styles.alignmentButtons}>
        <IconButton
          variant="tertiary"
          size="md"
          icon={AlignVerticalCenter}
          onPress={() => actions['align-center-horizontal'].onSelect()}
          aria-label="Align horizontal centers"
        />
        <IconButton
          variant="tertiary"
          size="md"
          icon={() => <AlignHorizontalCenter1 size={20} />}
          onPress={() => actions['align-center-vertical'].onSelect()}
          aria-label="Align vertical centers"
        />
        <IconButton
          aria-label="Align top"
          variant="tertiary"
          size="md"
          icon={AlignUp2}
          onPress={() => actions['align-top'].onSelect()}
        />
        <IconButton
          aria-label="Align bottom"
          variant="tertiary"
          size="md"
          icon={AlignDown2}
          onPress={() => actions['align-bottom'].onSelect()}
        />
        <IconButton
          aria-label="Align left"
          variant="tertiary"
          size="md"
          icon={AlignLeft2}
          onPress={() => actions['align-left'].onSelect()}
        />
        <IconButton
          aria-label="Align right"
          variant="tertiary"
          size="md"
          icon={AlignRight2}
          onPress={() => actions['align-right'].onSelect()}
        />
      </div>
    </div>
  )
}

export const Alignment = () => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileAlignment /> : <DesktopAlignment />
}
